import { isServer, path } from '../../browser'
import { isEmpty } from '../../generalUtils'
import { logError } from '../../logError'

const getLoginFlag = () => {
    if (isServer()) {
        return
    }
    if (path(['localStorage'], window) && typeof window.localStorage != 'undefined') {
        const onLoginPushFlag = localStorage.getItem('ON_LOGIN_PUSH')
        let loginFlag = onLoginPushFlag ? JSON.parse(onLoginPushFlag) : false
        if (loginFlag) {
            return true
        }
        return false
    }
}

export const sendProfileData = (payload: any) => {
    if (path(['localStorage'], window) && typeof window.localStorage != 'undefined') {
        if (getLoginFlag()) {
            return
        }
        window.localStorage.setItem('ON_LOGIN_PUSH', 'true')
        window.clevertap.onUserLogin.push({ Site: payload })
    }
}

export const clearLoginPushFlag = () => {
    if (isServer()) {
        return
    }

    if (path(['localStorage'], window) && typeof window.localStorage != 'undefined') {
        window.localStorage.removeItem('ON_LOGIN_PUSH')
    }
}

export const updateProfileData = (payload: any) => {
    try {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ClevertapInterface) {
            const message = { action: 'profilePush', properties: JSON.parse(JSON.stringify(payload)) }
            window.webkit.messageHandlers.ClevertapInterface.postMessage(message)
        } else if (window.ClevertapInterface) {
            window.ClevertapInterface.pushProfile(JSON.stringify(payload))
        } else {
            window.clevertap.profile.push({ Site: payload })
        }
    } catch (e) {
        logError('updateProfileData', e)
    }
}
export const responseMapper = (data: any) => {
    try {
        if (!isEmpty(data)) {
            if (data.travellers) {
                data = { ...data, ...data.customer }
                data.travellerDetails = data.travellers
            }
            const site: any = {
                Identity: data.id || data.userId || '',
                Email: data.username || '',
                Phone: `${data.countryCode}${data.mobile}`,
                Gender: data.gender || '',
                'MSG-whatsapp': true,
                'MSG-sms': true,
                'MSG-email': false,
                'MSG-push': true
            }
            for (let i = 0; i < data.travellerDetails; i++) {
                const val = data.travellerDetails[i]
                if (val.isRegistered) {
                    site.Name = `${val.personalDetails.firstName} ${val.personalDetails.lastName}`
                    site.DOB = new Date(val.personalDetail.dateOfBirth)
                    break
                }
            }
            return site
        }
    } catch (e) {
        logError('responseMapper', e)
    }
}
export function invokeCustomEvent(EVENT_TYPE: string, obj: Object) {
    if (typeof document !== 'undefined') {
        const customEvent = new CustomEvent(EVENT_TYPE, { detail: { ...obj } })
        document.dispatchEvent(customEvent)
    }
}

export const loginPush = getLoginFlag()
